import { Link } from "react-router-dom";

const Home = () => (
  <section className="min-h-[80vh] bg-gradient-to-br from-yellow-100 via-amber-200 to-orange-100 px-6 py-20 flex flex-col items-center justify-center text-center shadow-inner rounded-lg animate-fade-in">
    <h2 className="text-4xl md:text-5xl font-extrabold text-amber-800 drop-shadow-md tracking-wide mb-4">
      <span className="text-teal-700">Coffe</span>
    </h2>
    <p className="text-lg md:text-xl text-gray-700 max-w-2xl font-medium mb-8">
      El lugar donde el aroma a café se mezcla con momentos inolvidables ☕
    </p>
    <img
      src="/logo2.jpg"
      alt="Interior del café"
      className="rounded-xl shadow-lg w-full max-w-3xl border border-teal-200"
    />

    <Link to="/productos">
      <button className="mt-10 px-6 py-3 bg-teal-700 text-white font-semibold rounded-lg hover:bg-teal-800 transition boton-llamativo">
        Ver Menú
      </button>
    </Link>
  </section>
);

export default Home;
